module.exports = __webpack_public_path__ + "images/users/opt_in_modal/title_02ecb61a14eed4dd3e1da9de6e521a9d.png";